"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRED_FIELD_RULE = exports.VALIDATION_TRIGGERS = exports.VALIDATION_MESSAGE = void 0;
exports.VALIDATION_MESSAGE = {
    REQUIRED_FIELD: 'This field is required.',
};
exports.VALIDATION_TRIGGERS = {
    BLUR: 'blur',
};
exports.REQUIRED_FIELD_RULE = [
    { required: true, message: exports.VALIDATION_MESSAGE.REQUIRED_FIELD, trigger: exports.VALIDATION_TRIGGERS.BLUR },
];
